export interface AppLogoProps {
  width?: number;
  height?: number;
}

export const AppLogo = ({ width = 100, height }: AppLogoProps) => {
  return (
    <div
      style={{
        borderRadius: 10,
        overflow: "hidden",
        display: "block",
        width,
        height,
      }}
    >
      <img className="full" src={"/logo.png"} />
    </div>
  );
};
